module.exports = __webpack_public_path__ + "static/media/PUPPET SHOW SMALL (1).fe913023.png";